package ir.yusefpasha.style

import com.varabyte.kobweb.compose.css.CSSTransition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderColor
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.silk.components.style.ComponentStyle
import com.varabyte.kobweb.silk.components.style.focus
import com.varabyte.kobweb.silk.components.style.hover
import ir.yusefpasha.models.Theme
import ir.yusefpasha.util.Constants
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px

val InputStyle by ComponentStyle {
    base {
        Modifier
            .border(
                width = 2.px,
                style = LineStyle.Solid,
                color = Theme.LightGray.rgb
            )
            .transition(
                CSSTransition(property = "border", duration = Constants.ANIMATION_DURATION)
            )
    }

    focus {
        Modifier
            .border(
                width = 2.px,
                style = LineStyle.Solid,
                color = Theme.Primary.rgb
            )
            .transition(
                CSSTransition(property = "border", duration = Constants.ANIMATION_DURATION)
            )
    }

    hover {
        Modifier
            .border(
                width = 2.px,
                style = LineStyle.Solid,
                color = Theme.Primary.rgb
            )
            .transition(
                CSSTransition(property = "border", duration = Constants.ANIMATION_DURATION)
            )
    }
}